import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cli/CliClient.tsx");
